import React from 'react'
import "../css/emptyPosition.css"
import { EmptyPositionIcon } from '../../../../../../assets-module/asset-configuration/icon/iconExporter/iconExporter'

type Props = {}

const EmptyPosition = (props: Props) => {
  return (
    <div className='scl--empty-position-poster-box'>
      <div className='scl--empty-ppb-style'>
        <EmptyPositionIcon/>
        <span className='scl--eps-text-on'>
          No Open Positions
        </span>
        <span className='scl--eps-text-to'>
          There are currently no job openings available.
        </span>
      </div>
    </div>
  )
}

export default EmptyPosition